import { Center } from '@/components/ui/center'
import { Spinner } from '@/components/ui/spinner'
import { fetchTableCoversByFolderThunk, selectTableCoversMetaState } from '@/redux/slices/tableCoverSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { BaseFileEnum } from '@/typings/domain'
import { useFocusEffect } from 'expo-router'
import { useCallback } from 'react'
import TableCoverList from './TableCoverList'

type TableCoversByFolderProps = {
  folderToken: string
}

export default function TableCoversByFolder({ folderToken }: TableCoversByFolderProps) {
  const dispatch = useAppDispatch()
  const tableCoversLoaded = useAppSelector(
    state => selectTableCoversMetaState(state, { folderToken }, BaseFileEnum.Form).loaded
  )
  const folderCoversLoaded = useAppSelector(
    state => selectTableCoversMetaState(state, { folderToken }, BaseFileEnum.FormFolder).loaded
  )

  const refetchCovers = useCallback(() => {
    dispatch(fetchTableCoversByFolderThunk({ folderToken, type: BaseFileEnum.FormFolder, reset: true }))
    dispatch(fetchTableCoversByFolderThunk({ folderToken, type: BaseFileEnum.Form, reset: true }))
  }, [dispatch, folderToken])

  useFocusEffect(refetchCovers)

  const handleLoadMore = useCallback(
    (type: BaseFileEnum) => {
      dispatch(fetchTableCoversByFolderThunk({ folderToken, type }))
    },
    [dispatch, folderToken]
  )

  if (!folderCoversLoaded && !tableCoversLoaded) {
    return (
      <Center className="h-[20vh]">
        <Spinner />
      </Center>
    )
  }

  return <TableCoverList folderToken={folderToken} includeFolder onLoadMore={handleLoadMore} onRefresh={refetchCovers} />
}
